// Utility to sanitize error messages and provide user-friendly feedback

export const getUserFriendlyError = (error) => {
  // If no error response, return generic message
  if (!error?.response?.data?.errors) {
    return "Something went wrong. Please try again.";
  }

  const errorMessage = error.response.data.errors[0]?.message || "";

  // Handle specific error cases with user-friendly messages
  if (errorMessage.includes("has to be unique")) {
    if (errorMessage.includes("email")) {
      return "This email address is already registered. Please use a different email or try logging in.";
    }
    if (errorMessage.includes("nrc")) {
      return "This NRC/ID number is already registered. Please contact support if you believe this is an error.";
    }
    if (errorMessage.includes("business_registration_number")) {
      return "This business registration number is already registered. Please contact support if you believe this is an error.";
    }
    return "This information is already registered in our system. Please use different details.";
  }

  // Handle validation errors
  if (errorMessage.includes("Invalid payload")) {
    return "Please check all required fields and try again.";
  }

  // Handle authentication errors
  if (errorMessage.includes("Invalid credentials") || errorMessage.includes("Invalid token")) {
    return "Invalid email or password. Please try again.";
  }

  // Handle permission errors
  if (errorMessage.includes("forbidden") || errorMessage.includes("not allowed")) {
    return "You don't have permission to perform this action.";
  }

  // Handle not found errors
  if (errorMessage.includes("not found")) {
    return "The requested information was not found.";
  }

  // For any other errors, return a generic message
  // DON'T expose internal error messages
  console.error("Original error:", errorMessage);
  return "Unable to complete your request. Please try again or contact support.";
};

export const getFieldError = (error, fieldName) => {
  if (!error?.response?.data?.errors) {
    return null;
  }

  const errors = error.response.data.errors;
  const fieldError = errors.find(err =>
    err.extensions?.field === fieldName ||
    err.message?.includes(fieldName)
  );

  return fieldError ? getUserFriendlyError({ response: { data: { errors: [fieldError] } } }) : null;
};
